import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import CurrencyView from '../modules/CurrencyView';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Helper
import { getDateUsingTimeZone } from '../../../helpers/dateRange';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class CancelledByGuest extends Component {
	static propTypes = {
		content: PropTypes.shape({
			hostName: PropTypes.string.isRequired,
			checkIn: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired,
			payoutToHost: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired
		}).isRequired
	};

	render() {
		const { content: { hostName, checkIn, listTitle, payoutToHost, currency, logo, country, siteName, checkOut } } = this.props;
		let checkInDate, momentStartDate, today, checkOutDate,interval,isPastDay
		checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : ''
		momentStartDate = moment(checkIn).startOf('day');
		checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : ''

		today = getDateUsingTimeZone(country, false), interval = momentStartDate.diff(today, 'days'), isPastDay = false;
		if (interval < 0) {
			isPastDay = true;
		}

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Bonjour {hostName},
					</div>
					<EmptySpace height={20} />
					<div>
						<div style={marginBottom}>Malheureusement, le voyageur a annulé sa réservation pour {listTitle} du {checkInDate} au {checkOutDate}.</div>
						{
							payoutToHost > 0 && <span>
								Conformément à la politique d'annulation, vous recevrez un versement de <CurrencyView amount={payoutToHost} currency={currency} />, et nous vous en informerons.
							</span>
						}
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default CancelledByGuest;